import { combineReducers } from 'redux';

import {
  OUTLET_PAGE_HIDE_REACTIVATE_OUTLET_WITHOUT_PAY,
  OUTLET_PAGE_LIST_CLOSE_RIGHT_COLUMN,
  OUTLET_PAGE_LIST_DISABLE_PAY_BUTTON,
  OUTLET_PAGE_LIST_ENABLE_PAY_BUTTON,
  OUTLET_PAGE_LIST_HIDE_ADD_OUTLET_MODAL,
  OUTLET_PAGE_LIST_HIDE_CONFIRM_REACTIVATE_OUTLET_MODAL,
  OUTLET_PAGE_LIST_HIDE_PAYMENT_GATEWAY_ERROR_MODAL,
  OUTLET_PAGE_LIST_OPEN_RIGHT_COLUMN,
  OUTLET_PAGE_LIST_SET_ON_LOADING,
  OUTLET_PAGE_LIST_SET_OUTLET_DETAIL,
  OUTLET_PAGE_LIST_SET_OUTLET_PRICE,
  OUTLET_PAGE_LIST_SET_OUTLET_SLOTS,
  OUTLET_PAGE_LIST_SET_OUTLETS,
  OUTLET_PAGE_LIST_SET_PAY_BUTTON_MESSAGE,
  OUTLET_PAGE_LIST_SET_PENDING_PAYMENT_MESSAGE,
  OUTLET_PAGE_LIST_SET_PROFILE,
  OUTLET_PAGE_LIST_SET_REACTIVATED_OUTLET,
  OUTLET_PAGE_LIST_SET_SUBSCRIPTION_STATUS,
  OUTLET_PAGE_LIST_SET_USED_OUTLET_SLOTS,
  OUTLET_PAGE_LIST_SET_DISABLE_SAVE_OUTLET_BUTTON,
  OUTLET_PAGE_LIST_SHOW_ADD_OUTLET_MODAL,
  OUTLET_PAGE_LIST_SHOW_CONFIRM_REACTIVATE_OUTLET_MODAL,
  OUTLET_PAGE_LIST_SHOW_PAYMENT_GATEWAY_ERROR_MODAL,
  OUTLET_PAGE_SHOW_REACTIVATE_OUTLET_WITHOUT_PAY,
  OUTLET_PAGE_SET_ON_LOADING_REACTIVATE_OUTLET_WITHOUT_PAY_MODAL,
  OUTLET_PAGE_SET_OPEN_PAYMENT_METHOD_MODAL,
  OUTLET_PAGE_SET_PAYMENT_METHOD_LIST,
  OUTLET_PAGE_SHOW_CLONE_OUTLET,
  OUTLET_PAGE_SHOW_CLONE_OUTLET_PROGRESS,
  OUTLET_PAGE_HIDE_CLONE_OUTLET_PROGRESS,
  OUTLET_PAGES_UPDATE_CLONING_PROGRESS,
  OUTLET_PAGES_CLONE_SUCCESS,
  OUTLET_PAGES_CLONE_FAILED,
  OUTLET_PAGES_SHOW_CLONE_NOTIFICATION,
  OUTLET_PAGES_HIDE_CLONE_NOTIFICATION,
  OUTLET_PAGES_CLONE_RESET,
  OUTLET_PAGES_RESET_CLONING_PROGRESS,
  OUTLET_PAGES_SET_CLONE_OUTLET_DATA,
  OUTLET_PAGES_SET_CLONE_ELIGIBLE,
  OUTLET_PAGES_SET_CLONE_FORBIDDEN,
  OUTLET_PAGES_SET_CLONE_ID,
  OUTLET_PAGES_REMOVE_CLONE_ID,
  OUTLET_PAGES_SUBMIT_CLONE_OUTLET,
  OUTLET_PAGE_LIST_SHOW_SAUDAGAR_INFO_MODAL,
  OUTLET_PAGE_LIST_HIDE_SAUDAGAR_INFO_MODAL,
  OUTLET_PAGES_SET_GOBIZ_LINKING_MERCHANT_INFO,
  OUTLET_PAGES_SET_GOBIZ_LINKING_MERCHANT_INFO_REMOVED,
  OUTLET_PAGE_LIST_SHOW_GOBIZ_LINKING_RECOMMENDATION_MODAL,
  OUTLET_PAGE_LIST_SHOW_GOBIZ_LINKING_RECOMMENDATION_MODAL_CLOSED,
  OUTLET_PAGE_LIST_SHOW_UNLINK_GOBIZ_MODAL,
  OUTLET_PAGE_LIST_SHOW_UNLINK_GOBIZ_MODAL_CLOSED,
} from '../../actions/outletPages/list/constants';
import createReducer from '../../utils/createReducer';

const showSaudagarInfoModal = createReducer(false, {
  [OUTLET_PAGE_LIST_SHOW_SAUDAGAR_INFO_MODAL]: (draft, { payload }) => {
    return {
      show: true,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      moka: payload.moka,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      saudagar: payload.saudagar,
    };
  },
  [OUTLET_PAGE_LIST_HIDE_SAUDAGAR_INFO_MODAL]: () => {
    return {
      show: false,
      moka: {},
      saudagar: {},
    };
  },
});

const disablePayButton = createReducer(false, {
  [OUTLET_PAGE_LIST_ENABLE_PAY_BUTTON]: () => false,
  [OUTLET_PAGE_LIST_DISABLE_PAY_BUTTON]: () => true,
});

const disableSaveOutletButton = createReducer(false, {
  [OUTLET_PAGE_LIST_SET_DISABLE_SAVE_OUTLET_BUTTON]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.disabled,
});

const featureSubscriptions = createReducer([], {
  [OUTLET_PAGE_LIST_SET_SUBSCRIPTION_STATUS]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.featureSubscriptions,
});

const isOnLoadingReactivateOutletWithoutPayModal = createReducer(false, {
  [OUTLET_PAGE_SET_ON_LOADING_REACTIVATE_OUTLET_WITHOUT_PAY_MODAL]: (
    draft,
    { payload }
  ) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.isOnLoading,
});

const onLoadingPayButton = createReducer(false, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [OUTLET_PAGE_LIST_SET_ON_LOADING]: (draft, { payload }) => payload.onLoading,
});

const openPaymentMethodModal = createReducer(false, {
  [OUTLET_PAGE_SET_OPEN_PAYMENT_METHOD_MODAL]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.openPaymentMethodModal,
});

const openRightColumn = createReducer(false, {
  [OUTLET_PAGE_LIST_OPEN_RIGHT_COLUMN]: () => true,
  [OUTLET_PAGE_LIST_CLOSE_RIGHT_COLUMN]: () => false,
});

const outletDetail = createReducer(null, {
  [OUTLET_PAGE_LIST_SET_OUTLET_DETAIL]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.outletDetail,
});

const outletPrice = createReducer(
  {},
  {
    [OUTLET_PAGE_LIST_SET_OUTLET_PRICE]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.outletPrice,
  }
);

const outlets = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [OUTLET_PAGE_LIST_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const outletSlots = createReducer(null, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [OUTLET_PAGE_LIST_SET_OUTLET_SLOTS]: (draft, { payload }) => payload.slots,
});

const payButtonMessage = createReducer('Pay', {
  [OUTLET_PAGE_LIST_SET_PAY_BUTTON_MESSAGE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.buttonMessage,
});

const paymentMethodList = createReducer([], {
  [OUTLET_PAGE_SET_PAYMENT_METHOD_LIST]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.paymentMethodList,
});

const pendingPaymentMessage = createReducer(null, {
  [OUTLET_PAGE_LIST_SET_PENDING_PAYMENT_MESSAGE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.pendingMessage,
});

const profile = createReducer(null, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [OUTLET_PAGE_LIST_SET_PROFILE]: (draft, { payload }) => payload.profile,
});

const reactivatedOutlet = createReducer(null, {
  [OUTLET_PAGE_LIST_SET_REACTIVATED_OUTLET]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.outlet,
});

const showAddOutletModal = createReducer(false, {
  [OUTLET_PAGE_LIST_SHOW_ADD_OUTLET_MODAL]: () => true,
  [OUTLET_PAGE_LIST_HIDE_ADD_OUTLET_MODAL]: () => false,
});

const showConfirmReactivateOutletModal = createReducer(false, {
  [OUTLET_PAGE_LIST_SHOW_CONFIRM_REACTIVATE_OUTLET_MODAL]: () => true,
  [OUTLET_PAGE_LIST_HIDE_CONFIRM_REACTIVATE_OUTLET_MODAL]: () => false,
});

const showPaymentGatewayErrorModal = createReducer(false, {
  [OUTLET_PAGE_LIST_SHOW_PAYMENT_GATEWAY_ERROR_MODAL]: () => true,
  [OUTLET_PAGE_LIST_HIDE_PAYMENT_GATEWAY_ERROR_MODAL]: () => false,
});

const showReactivateOutletWithoutPayModal = createReducer(false, {
  [OUTLET_PAGE_SHOW_REACTIVATE_OUTLET_WITHOUT_PAY]: () => true,
  [OUTLET_PAGE_HIDE_REACTIVATE_OUTLET_WITHOUT_PAY]: () => false,
});

const usedOutletSlots = createReducer(null, {
  [OUTLET_PAGE_LIST_SET_USED_OUTLET_SLOTS]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.slots,
});

const showCloneOutletOption = createReducer(false, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [OUTLET_PAGE_SHOW_CLONE_OUTLET]: (draft, { payload }) => payload.showOption,
});

const showCloneOutletProgress = createReducer(false, {
  [OUTLET_PAGE_SHOW_CLONE_OUTLET_PROGRESS]: (draft, { payload }) => {
    return {
      showProgress: true,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      outlet: payload.outlet,
    };
  },
  [OUTLET_PAGE_HIDE_CLONE_OUTLET_PROGRESS]: () => {
    return {
      showProgress: false,
      outlet: {},
    };
  },
});

const updateCloningProgress = createReducer(null, {
  [OUTLET_PAGES_UPDATE_CLONING_PROGRESS]: (draft, { payload }) => {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    return payload.progress.data;
  },
  [OUTLET_PAGES_RESET_CLONING_PROGRESS]: () => null,
});

const cloneResult = createReducer(null, {
  [OUTLET_PAGES_CLONE_SUCCESS]: (draft, { payload }) => {
    return {
      success: true,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      outlet: payload.outlet,
    };
  },
  [OUTLET_PAGES_CLONE_FAILED]: (draft, { payload }) => {
    return {
      success: false,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      outlet: payload.outlet,
    };
  },
  [OUTLET_PAGES_CLONE_RESET]: () => {
    return {
      success: null,
      outlet: null,
    };
  },
});

const showCloneOutletNotification = createReducer(false, {
  [OUTLET_PAGES_SHOW_CLONE_NOTIFICATION]: (draft, { payload }) => {
    return {
      showNotification: true,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      notification: payload.notification,
    };
  },
  [OUTLET_PAGES_HIDE_CLONE_NOTIFICATION]: () => {
    return {
      showNotification: false,
      notification: null,
    };
  },
});

const cloneOutletDropdown = createReducer(null, {
  [OUTLET_PAGES_SET_CLONE_OUTLET_DATA]: (draft, { payload }) => {
    return {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      outlets: payload.data,
    };
  },
});

const isCloningEligible = createReducer(false, {
  [OUTLET_PAGES_SET_CLONE_ELIGIBLE]: () => true,
  [OUTLET_PAGES_SET_CLONE_FORBIDDEN]: () => false,
});

const cloneOutletId = createReducer(null, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [OUTLET_PAGES_SET_CLONE_ID]: (draft, { payload }) => payload.id,
  [OUTLET_PAGES_REMOVE_CLONE_ID]: () => null,
});

const cloneOutletSubmit = createReducer(null, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [OUTLET_PAGES_SUBMIT_CLONE_OUTLET]: (draft, { payload }) => payload.outlet,
});

const gobizLinkingMerchantInfo = createReducer(null, {
  [OUTLET_PAGES_SET_GOBIZ_LINKING_MERCHANT_INFO]: (draft, { payload }) => {
    return {
      show: true,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      moka: payload.moka,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      saudagar: payload.merchantInfo,
    };
  },
  [OUTLET_PAGES_SET_GOBIZ_LINKING_MERCHANT_INFO_REMOVED]: () => null,
});

const gobizLinkingRecommendation = createReducer(null, {
  [OUTLET_PAGE_LIST_SHOW_GOBIZ_LINKING_RECOMMENDATION_MODAL]: (
    draft,
    { payload }
  ) => {
    return {
      show: true,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      moka: payload.moka,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      saudagar: payload.saudagar,
    };
  },
  [OUTLET_PAGE_LIST_SHOW_GOBIZ_LINKING_RECOMMENDATION_MODAL_CLOSED]: () => null,
});

const showUnlinkGoBizModal = createReducer(false, {
  [OUTLET_PAGE_LIST_SHOW_UNLINK_GOBIZ_MODAL]: (draft, { payload }) => {
    return {
      show: true,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      moka: payload.moka,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      saudagar: payload.saudagar,
    };
  },
  [OUTLET_PAGE_LIST_SHOW_UNLINK_GOBIZ_MODAL_CLOSED]: () => null,
});

export default combineReducers({
  disablePayButton,
  disableSaveOutletButton,
  featureSubscriptions,
  isOnLoadingReactivateOutletWithoutPayModal,
  onLoadingPayButton,
  openPaymentMethodModal,
  openRightColumn,
  outletDetail,
  outletPrice,
  outlets,
  outletSlots,
  payButtonMessage,
  paymentMethodList,
  pendingPaymentMessage,
  profile,
  reactivatedOutlet,
  showAddOutletModal,
  showConfirmReactivateOutletModal,
  showPaymentGatewayErrorModal,
  showReactivateOutletWithoutPayModal,
  usedOutletSlots,
  showCloneOutletOption,
  showCloneOutletProgress,
  updateCloningProgress,
  cloneResult,
  showCloneOutletNotification,
  cloneOutletDropdown,
  isCloningEligible,
  cloneOutletId,
  cloneOutletSubmit,
  showSaudagarInfoModal,
  gobizLinkingMerchantInfo,
  gobizLinkingRecommendation,
  showUnlinkGoBizModal,
});
